import React from "react";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import podcastMain from "../../../podCastImage/podcastBanner.png";
import podcastBannerMob from "../../../podCastImage/podCastBannerMob.png";

import { StyledBox, StyledGrid, StyledTypography } from "@hcl-commerce-store-sdk/react-component";

import AsyncCall from "../../../_foundation/gtm/async.service";
import { CLICK } from "../../../_foundation/constants/gtm";
import { ImageLayout } from "../image";

const DoorStoryBanner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleAllEpisodesClick = () => {
    AsyncCall.sendClick(CLICK.CTA, {
      btn_label: "Ecouter tous les épisodes",
      page_type: "page_podcast",
      content_group: "contenu",
      click_destination: "https://feeds.acast.com/public/shows/69e88f8a289eeb2c7b6bfcc2",
    });

    window.open("https://feeds.acast.com/public/shows/69e88f8a289eeb2c7b6bfcc2", "_blank", "noopener");
  };

  return (
    <StyledBox>
      <StyledBox
        sx={{
          width: "100%",
          position: "relative",
          overflow: "hidden",
          backgroundColor: "#0F71A8",
          backgroundSize: "cover",
          backgroundPosition: isMobile ? "top center" : "center",
          backgroundRepeat: "no-repeat",

          display: "flex",

          alignItems: "stretch",

          pt: 0,
          pb: 0,
        }}>
        <StyledGrid
          container
          sx={{
            width: "100%",
            alignItems: "stretch",
            height: "100%",
            position: "relative",
            zIndex: 2,
          }}>
          {/* LEFT CONTENT */}
          <StyledGrid
            item
            xs={12}
            md={6}
            sx={{
              textAlign: { xs: "center", md: "left" },
              px: { xs: 3, sm: 6, md: 8, lg: 14 },
              pt: { xs: 3, sm: 1, md: 12 },
              pb: { xs: 0, md: 0 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
              alignItems: isMobile && "center",
            }}>
            {/* TOP TEXT */}
            <StyledTypography
              sx={{
                fontSize: { xs: "12px", md: "16px" },
                fontWeight: 500,
                letterSpacing: "6px",
                textTransform: "uppercase",
                color: "#fff",
                mb: { xs: 2, md: 3 },
              }}>
              Lapeyre
            </StyledTypography>

            {/* BADGE */}
            <StyledBox
              sx={{
                display: "inline-block",
                backgroundColor: "#fff",
                px: { xs: 2.5, md: 3 },
                py: { xs: 1.5, md: 1.2 },
                borderRadius: "10px",
                mb: { xs: 3, md: 4 },
                width: "fit-content",
              }}>
              <StyledTypography
                component="h1"
                sx={{
                  fontSize: { xs: "24px", sm: "34px", md: "48px" },
                  fontWeight: 700,
                  lineHeight: 1,
                  color: "#0a6ea8",
                  textTransform: "uppercase",
                }}>
                Door Story
              </StyledTypography>
            </StyledBox>

            {/* HEADING */}
            <StyledTypography
              component="h2"
              sx={{
                fontSize: { xs: "16px", sm: "24px", md: "32px", lg: "32px" },
                fontWeight: 900,
                lineHeight: 1,
                color: "#fff",
                mb: { xs: 2, md: 4 },
                maxWidth: { md: "620px" },
                mx: { xs: "auto", md: 0 },
              }}>
              La série podcast de Lapeyre qui raconte des moments de vie !
            </StyledTypography>

            {/* DESCRIPTION */}
            <StyledTypography
              // component="h2"
              sx={{
                fontSize: { xs: "12px", sm: "16px", md: "18px" },
                lineHeight: 1.4,
                fontWeight: 400,
                color: "#fff",
                mb: { xs: 4, md: 5 },
                maxWidth: { xs: "300px", sm: "420px", md: "560px" },
                mx: { xs: "auto", md: 0 },
              }}>
              {isMobile ? (
                <>
                  Une fiction sonore en trois saisons, <br />
                  ancrée dans le réel.
                  <br />
                  Une série pensée comme une œuvre, <br />
                  pas comme un contenu de marque.
                </>
              ) : (
                <>
                  Une fiction sonore en trois saisons, ancrée dans le réel.
                  <br />
                  Une série pensée comme une œuvre, pas comme un contenu de marque.
                </>
              )}
            </StyledTypography>

            {/* BUTTON */}
            <Button
              variant="contained"
              // fullWidth={isMobile}
              onClick={handleAllEpisodesClick}
              sx={{
                maxWidth: { xs: "290px", sm: "340px", md: "auto" },
                backgroundColor: "#fff",
                color: "#0a6ea8",
                fontWeight: 800,
                fontSize: { xs: "14px", md: "16px" },
                px: { md: 4 },
                py: { xs: 4, md: 5 },
                mb: { xs: 0, md: 5 },
                borderRadius: "10px",
                textTransform: "uppercase",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                  boxShadow: "none",
                },
              }}>
              Écouter tous les épisodes
            </Button>
          </StyledGrid>

          {/* RIGHT IMAGE DESKTOP */}
          {!isMobile && (
            <StyledGrid
              item
              md={6}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                // alignItems: "flex-end",
                alignItems: "stretch",
                p: 0,
                overflow: "hidden",
                height: "100%",
              }}>
              <ImageLayout
                src={podcastMain}
                alt="pod cast"
                width="100%"
                height="100%"
                priority
                styles={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </StyledGrid>
          )}
        </StyledGrid>
      </StyledBox>

      {/* MOBILE IMAGE BOTTOM */}
      {/* {isMobile && (
        <StyledBox
          sx={{
            width: "100%",
            lineHeight: 0,
            mt: 0,
          }}>
          <ImageLayout
            src={podcastBannerMob}
            alt="pod cast"
            width="100%"
            height="100%"
            className="bg-image"
            priority={true}
          />
        </StyledBox>
      )} */}
      {isMobile && (
        <StyledBox
          sx={{
            width: "100%",
            lineHeight: 0,
            fontSize: 0,
            mt: "-1px",
            display: "block",
            overflow: "hidden",
          }}>
          <ImageLayout
            src={podcastBannerMob}
            alt="pod cast"
            width="100%"
            height="100%"
            className="bg-image"
            priority={true}
            styles={{
              display: "block",
              width: "100%",
              height: "auto",
            }}
          />
        </StyledBox>
      )}
    </StyledBox>
  );
};

export default DoorStoryBanner;
